import { render, staticRenderFns } from "./GoodsClassList.vue?vue&type=template&id=3bc541b2&scoped=true&"
import script from "./GoodsClassList.vue?vue&type=script&lang=js&"
export * from "./GoodsClassList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClassList.vue?vue&type=style&index=0&id=3bc541b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc541b2",
  null
  
)

export default component.exports